import React, { useState, useEffect } from 'react';
import styled from "styled-components";
import {ClickSpan} from "@/components/anchor";

interface TimerProps {
    seconds: number;
    text: string;
    onClick: () => void;
}

const Timer: React.FC<TimerProps> = ({ seconds, text , onClick}) => {
    const [timeLeft, setTimeLeft] = useState<number>(seconds);
    const [isActive, setIsActive] = useState<boolean>(true);

    useEffect(() => {
        let timer: NodeJS.Timeout;
        if (isActive && timeLeft > 0) {
            timer = setTimeout(() => {
                setTimeLeft(timeLeft - 1);
            }, 1000);
        } else if (timeLeft === 0) {
            setIsActive(false);
        }

        return () => clearTimeout(timer);
    }, [isActive, timeLeft]);

    const handleClick = () => {
        setIsActive(true);
        setTimeLeft(seconds);
        onClick();
    };

    return (
        <>
            {timeLeft > 0 && <Span> {text} {timeLeft} сек.</Span>}
            {timeLeft === 0 && (
                <ClickSpan
                    style={{fontWeight: 400, textAlign: 'center'}}
                    $reg={true}
                    onClick={() => handleClick()}
                >
                    Получить новый код
                </ClickSpan>
            )}
        </>


    );
};

export default Timer;
const Span = styled.span`
  text-align: center;
  color: rgba(255, 255, 255, 0.8);
`;